<div fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="{ odd: odd, even: even }" class="row">
    <div fxFlex="25" class="col" (click)="showDescription = !showDescription">{{ priceListCode.Code }}</div>
    <div fxFlex="25" class="col" (click)="showDescription = !showDescription">{{ priceListCode.Name }}</div>
    <div fxFlex="25" class="col" (click)="showDescription = !showDescription" *ngIf="!canChangePrice">{{ priceListCode.FinalPrice }}</div>
    <div fxFlex="25" class="col"  *ngIf="canChangePrice">
        <mat-form-field>
            <input type="number" matInput inputmode="numeric" min="0" max="999999" [(value)]="priceListCode.FinalPrice" (change)="onChangePrice($event)">
        </mat-form-field>
    </div>
    <div fxFlex="25" class="col">
        <!-- <button mat-raised-button color="primary"
            (click)="onSelect($event)">{{ 'TREATMENT.SELECT'| translate }}</button>
        </div> -->
        <mat-checkbox color="primary" (change)="onChange($event)" [checked]="priceListCode.Selected"></mat-checkbox>
    </div>
</div>
<div *ngIf="showDescription" fxLayout="row" fxLayoutAlign="space-between" [ngClass]="{ odd: odd, even: even }"
    class="row">
    <div fxFlex="25" fxLayoutAlign="start" class="col primary description">{{ 'TREATMENT.DESCRIPTION' | translate }}
    </div>
    <div fxFlex="75" fxLayoutAlign="start" class="col description">{{ priceListCode.Description }}</div>
</div>